import { Injectable } from '@angular/core';
import { ClientCreateOrEditDto } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientNameService {
  
  isShowClientName : ClientCreateOrEditDto;
  showClientName : BehaviorSubject< ClientCreateOrEditDto> = new BehaviorSubject< ClientCreateOrEditDto>(null)

  createCard(name:any){
    if(name.length !== 0) this.isShowClientName = name;
   }

   getCardList(){
    return this.isShowClientName;
   }
  constructor() {

   
   }

 
}
